// import swipeElement from "../../../../../plugins/wpmu-dev-dashboard/assets/js/dashboard-widget.min";

export function bannerInit() {
	let mainSliderBanner = document.querySelector('.main-slider-banner');
	let mainSliderContainer = document.querySelector('.main-slider-container');
	let mainSliderBannerControlH2 = document.querySelector(
		'.main-slider-banner-controls h2'
	);
	let controls = document.querySelectorAll(
		'.main-slider-banner-controls-grid-box'
	);

	// return false if main banner is not present
	if (!mainSliderBanner) {
		return false;
	}

	let windowWidth = window.innerWidth;
	const breakWidth = 1064;

	function updateSliderWidth() {
		// Get the current width of the browser window
		windowWidth = window.innerWidth;

		// Select all elements with the class 'main-slider-container-slide'
		var slides = document.querySelectorAll('.main-slider-container-slide');

		// Apply the width to each slide
		slides.forEach(function (slide) {
			slide.style.width = windowWidth + 'px';
		});

		var boxes = document.querySelectorAll(
			'.main-slider-banner-controls-grid-box'
		);
		if (windowWidth < breakWidth) {
			// Apply the width to each box
			boxes.forEach(function (box) {
				box.style.width = windowWidth + 'px';
			});
			mainSliderBanner.style.width = windowWidth * 3 + 'px';
			mainSliderBannerControlH2.style.width = windowWidth - 48 + 'px';
		} else {
			// Apply the width to each box
			boxes.forEach(function (box) {
				box.style.width = null;
			});
		}
		// Load in background images
		var backgroundImages = document.querySelectorAll(
			'[data-background-image]'
		);
		backgroundImages.forEach(function (el) {
			if (el.dataset.backgroundImage != '') {
				el.style.backgroundImage =
					'url(' + el.dataset.backgroundImage + ')';
				el.dataset.backgroundImage = '';
			}
		});

		var hideMes = document.querySelectorAll('.hide-me');
		hideMes.forEach(function (hideMe) {
			hideMe.classList.remove('hide-me');
		});
		mainSliderContainer.style.width = windowWidth * 3 + 'px';
		goToNextSlide(
			document.querySelector('.main-slider-container-slide-0'),
			true
		);
	}

	// Run the function on window load
	window.addEventListener('load', updateSliderWidth);
	updateSliderWidth;
	// Run the function on window resize
	window.addEventListener('resize', updateSliderWidth);

	var firstSlide = document.querySelector('.main-slider-container-slide');
	var firstBox = document.querySelector(
		'.main-slider-banner-controls-grid-box'
	);
	var progressBar = document.querySelector('.progress-bar-0 span');
	var slideInterval;
	// Add the 'active' class to this element
	if (firstSlide) {
		firstSlide.classList.add('in-view');
		firstSlide.classList.add('active');
		firstBox.classList.add('show-border', 'active');
		progressBar.classList.add('animate');
	}

	function setProgress(slideIndex) {
		var firstProgressBar = document.querySelector('.progress-bar-0 span');
		var secondProgressBar = document.querySelector('.progress-bar-1 span');
		var thirdProgressBar = document.querySelector('.progress-bar-2 span');

		firstProgressBar.classList.remove('animate', 'show-me');
		secondProgressBar.classList.remove('animate', 'show-me');
		thirdProgressBar.classList.remove('animate', 'show-me');

		if (slideIndex == 2) {
			firstProgressBar.classList.add('show-me');
			secondProgressBar.classList.add('show-me');
			setTimeout(function () {
				thirdProgressBar.classList.add('animate');
			}, 1);
		} else if (slideIndex == 1) {
			firstProgressBar.classList.add('show-me');
			setTimeout(function () {
				secondProgressBar.classList.add('animate');
			}, 1);
		} else {
			setTimeout(function () {
				firstProgressBar.classList.add('animate');
			}, 1);
		}
	}

	// Slide the main-slider-container-slide class to the left by the width of the first slide and add the 'active' class to the next slide
	function goToNextSlide(nextSlide = null, force = false) {
		var activeSlide = document.querySelector(
			'.main-slider-container-slide.active'
		);
		var activeSlideIndex = activeSlide.dataset.slideIndex * 1;

		var activeSlide = document.querySelector(
			'.main-slider-container-slide.active'
		);
		var activeBox = document.querySelector(
			'.main-slider-banner-controls-grid-box.active'
		);

		if (!nextSlide) {
			if (activeSlide.dataset.slideIndex > 1) {
				var nextSlide = document.querySelector(
					'.main-slider-container-slide-0'
				);
			} else {
				var nextSlide = activeSlide.nextElementSibling;
			}
		}
		var nextSlideIndex = nextSlide.dataset.slideIndex * 1;

		if (nextSlideIndex == activeSlideIndex && !force) {
			return false;
		}

		clearInterval(slideInterval);

		nextSlide.classList.add('in-view');
		var nextSlideWidth = nextSlide.offsetWidth;

		var nextBox = document.querySelector(
			'.main-slider-banner-controls-grid-box-' + (nextSlideIndex + 1)
		);

		// Remove the 'active' class from the active slide
		activeSlide.classList.remove('active');
		activeBox.classList.remove('active');
		// Add the 'active' class to the next slide
		nextSlide.classList.add('active');
		nextBox.classList.add('active');

		setProgress(nextSlideIndex);

		// Slide the main-slider-container-slide class to the left by the width of the first slide
		mainSliderContainer.style.transform =
			'translateX(-' + nextSlideWidth * nextSlideIndex + 'px)';
		if (windowWidth < breakWidth) {
			document.querySelector(
				'.main-slider-banner-controls-grid'
			).style.transform =
				'translateX(-' + nextSlideWidth * nextSlideIndex + 'px)';
		} else {
			document.querySelector(
				'.main-slider-banner-controls-grid'
			).style.transform = null;
		}
		// Reset the progress bars
		if (nextSlideIndex == 1) {
			// Wait 7 seconds and remove the animate class from the progress bars and the highlight from the highlight-blocks
			setTimeout(function () {
				var progressBarWrappers =
					document.querySelectorAll('.progress-bar-new');
				progressBarWrappers.forEach(function (barWrapper) {
					var bar = barWrapper.querySelector('span');
					bar.classList.remove('animate');
				});
			}, 7000);
		}
		// Wait 7 seconds and remove the animate class from the progress bars and the highlight from the highlight-blocks
		slideInterval = setInterval(goToNextSlide, 7000);
	}

	// and on manual click on the class main-slider-banner-controls-grid-box

	controls.forEach(function (control) {
		control.addEventListener('click', function (e) {
			var boxIndex = e.target.closest(
				'.main-slider-banner-controls-grid-box'
			).dataset.boxIndex;
			if (windowWidth < breakWidth) {
				if (boxIndex < 2) {
					boxIndex++;
				} else {
					boxIndex = 0;
				}
			}
			goToNextSlide(
				document.querySelector(
					'.main-slider-container-slide-' + boxIndex
				)
			);
		});
	});

	mainSliderBannerControlH2.addEventListener('click', function (e) {
		var boxIndex = document.querySelector(
			'.main-slider-banner-controls-grid-box.active'
		).dataset.boxIndex;
		if (windowWidth < breakWidth) {
			if (boxIndex < 2) {
				boxIndex++;
			} else {
				boxIndex = 0;
			}
		}
		goToNextSlide(
			document.querySelector('.main-slider-container-slide-' + boxIndex)
		);
	});
}
